import { defineMessages } from 'react-intl-next';

export default defineMessages({
	hasConfluenceLicenseTitle: {
		id: 'project-pages.improvement.templates.post-expand.title',
		defaultMessage: 'Create a page',
		description: 'Title for list of page templates',
	},
	hasConfluenceLicenseSubTitle: {
		id: 'project-pages.improvement.templates.post-expand.subtitle',
		defaultMessage: 'Popular templates',
		description: 'Information for list of page templates',
	},
});
